export const isParentPath = (parent: string, child: string) => {
  if (parent === child) return true;

  if (child.startsWith('/maintenance/certificates/execute/')) {
    return parent.startsWith('/maintenance/certificates/monitoring');
  }

  if (child.startsWith('/maintenance/certificates/') && !child.includes('monitoring')) {
    return parent === '/maintenance/certificates';
  }

  return false;
};
